// Legacy product-tour state (was Onboarding.js).
// Hernoemd naar OnboardingTour zodat de naam `Onboarding` vrij is voor de
// nieuwe signup-flow (zie OnboardingFlow.js).
import { createContext, useState } from "react";

export const OnboardingTour = createContext()

export const OnboardingTourProvider = (props) => {
    const [onboarding, setOnboarding] = useState(false)
    const [onboardingNotice, setOnboardingNotice] = useState(false)
    const [step, setStep] = useState(1)

    return(
        <OnboardingTour.Provider value={{onboarding, setOnboarding, step, setStep, onboardingNotice, setOnboardingNotice}}>
            {props.children}
        </OnboardingTour.Provider>
    )
}
